export function createWebGlContext(
  canvas: HTMLCanvasElement,
  options: { alpha?: boolean; preserveDrawingBuffer?: boolean } = {},
): WebGL2RenderingContext {
  const gl = canvas.getContext("webgl2", {
    antialias: true,
    alpha: options.alpha ?? false,
    premultipliedAlpha: false,
    preserveDrawingBuffer: options.preserveDrawingBuffer ?? false,
  });

  if (!gl) {
    throw new Error("WebGL2 is not available.");
  }

  return gl;
}
